import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import fr from "./locales/fr.json";

// Extensible: register additional locales here (e.g. es, ar, fa) — no other code changes needed.
export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", native: "English" },
  { code: "fr", label: "French (Canada)", native: "Français (Canada)" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    nonExplicitSupportedLngs: true, // maps fr-CA -> fr
    load: "languageOnly",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "jotbay_lang",
      caches: ["localStorage"],
    },
    returnNull: false,
  });

export const setAppLanguage = (lng) => {
  const code = (lng || "en").split("-")[0].toLowerCase();
  const safe = SUPPORTED_LANGUAGES.some((l) => l.code === code) ? code : "en";
  i18n.changeLanguage(safe);
  try { localStorage.setItem("jotbay_lang", safe); } catch { /* ignore */ }
  if (typeof document !== "undefined") document.documentElement.lang = safe;
};

export default i18n;
